import React from 'react';

function CUNotFound() {
    return (
        <div className="flex justify-center py-16">
            <div className="border p-5 rounded-md shadow">
                <div className="text-lg font-medium">
                    Could not found an account matching the request.
                </div>
                <div>You may have mistyped the address.</div>
                <div className="flex justify-end pt-8">
                    <img src="logo_technicost.png" alt="logo" className="h-10" />
                </div>
            </div>
        </div>
    );
}

export default CUNotFound;
